import { browserTime } from 'utils/time'
import { isOfferFulfillmentType } from 'modules/Business/modules/Offers/fulfillment'
import { period } from 'utils/constants'

/**
 * Format location/audience/offerLocation for display (matches Review Summary table).
 * Accepts audience shape (type, states, zips, local) or offerLocation (id.regionType, states, zips, local).
 *
 * Local: one row → single `address` string; two or more → "Multi-Address".
 */
export const getLocationDisplay = (location) => {
  if (!location) {
    return 'United States'
  }
  const loc = location.local
  const states = location.states
  const zips = location.zips
  const type = location.type || location.id?.regionType

  if (loc && Array.isArray(loc) && loc.length > 0) {
    if (loc.length === 1) {
      const raw = loc[0]?.address
      const text = typeof raw === 'string' ? raw.trim() : ''
      if (text) return text
    }
    return 'Multi-Address'
  }
  if (states && Array.isArray(states) && states.length > 0) {
    return states.join(',')
  }
  if (zips && Array.isArray(zips) && zips.length > 0) {
    return zips.join(',')
  }
  if (type === 'GLOBAL' || type?.toUpperCase() === 'GLOBAL') {
    return 'Global'
  }
  return 'United States'
}

/** Preview cards in Configure Offer wizard must not show address/location text. */
export const configureOfferPreviewCardProps = {
  hideLocation: true,
}

export const getOfferFulfillmentDefault = (businessFulfillment) =>
  isOfferFulfillmentType(businessFulfillment) ? businessFulfillment : ''

export const getClaimLimitDisplay = (budget = {}) => {
  if (budget.unlimitedClaims) return 'No limit'

  const claimPeriod = Object.keys(period).find(key => period[key] === budget.clickPeriod)
  return [budget.maxClick, claimPeriod].filter(value => value != null && value !== '').join(' ')
}

export const mapOfferToForm = (offer, businessFulfillment) => ({
  description: {
    title: offer.title,
    fulfillment:
      getOfferFulfillmentDefault(offer.fulfillment) ||
      getOfferFulfillmentDefault(businessFulfillment),
    keywords: offer.keywords,
    category: offer.category,
  },
  details: {
    headline1: offer.headline1,
    headline2: offer.headline2,
    description: offer.description,
    offerImage: offer.offerImage,
    siteUrl: offer.siteUrl,
    termsAndConditions: offer.termsAndConditions,
  },
  code: {
    promoCode: offer.promoCode,
    barcode: offer.barcode,
    qrCode: offer.qrCode,
  },
  budget: {
    amountPeriod: offer.budget.amountPeriod,
    clickPeriod: offer.budget.clickPeriod,
    maxAmount: offer.budget.maxAmount,
    maxClick: offer.budget.maxClick,
    unlimitedClaims: offer.budget.maxClick == null && offer.budget.clickPeriod == null,
    endDate: browserTime(offer.endDate).toISOString(),
    startDate: browserTime(offer.startDate).toISOString(),
  },
  audience: {
    type: offer.offerLocation.type,
    states: offer.offerLocation.states,
    zips: offer.offerLocation.zips,
    local: offer.offerLocation.local,
  }
})
